import FetchGetDataWithAuthNEW from "../services/FetchGetDataWithAuthNEW";

export default function FechGetgetAllEnabledPriceList(club, salesChannel) {

  var url = "/reservation/get_all_enabled_price_list/" + club + "/" + salesChannel; 

  return FetchGetDataWithAuthNEW(url);
}

